module.exports = __webpack_public_path__ + "img/tools.62937913.svg";